"use client";
import {Card, CardContent, CardFooter, CardHeader} from "@/components/ui/card";
import Avatar from "@/components/General/Avatar";
import {FaHeart, FaRegCommentAlt, FaRegHeart} from "react-icons/fa";
import Link from "next/link";
import LikeButton from "@/components/SocialNetworks/Like/LikeButton";
import {useState} from "react";
import CommentSection from "@/components/SocialNetworks/Comment/CommentSection";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import {formatDistance} from "date-fns";
import {fr} from "date-fns/locale";
import {reworkDate} from "@/lib/helpers/reworkDate";
import PostMenuEdit from "@/components/SocialNetworks/Posts/PostMenuEdit";
import LikeModal from "@/components/SocialNetworks/Like/LikeModal";
import {urlify} from "@/lib/helpers/textHelper";

export default function PostCard({idPost, content, firstname, lastname, userId, imageUser,likes,comments, createdAt,activity, training, medias,actualUserId, activities, trainings,editable = true}){
    const [commentOpen, setCommentOpen] = useState(false);
    const [likeOpen, setLikeOpen] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const isLike = likes.find(el => el.user_id === actualUserId);
    let extension = medias[0]?.path.split('.');


    return(
        <>
            <Card className="overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-300 bg-gradient-to-br from-white to-gray-50/50">
                <CardHeader className="pb-3">
                    <div className="flex justify-between items-start">
                        <div className="flex gap-4 items-center group">
                            <div className="relative">
                                <Avatar url={imageUser} height={50} width={50}/>
                                <div className="absolute inset-0 rounded-full bg-primary/10 group-hover:scale-110 transition-transform duration-300" />
                            </div>
                            <div>
                                <Link href={`/profile/${userId}`}>
                                    <button className="hover:text-primary font-semibold transition-colors duration-200 text-lg">
                                        {firstname} {lastname}
                                    </button>
                                </Link>
                                <p className="text-gray-400 text-xs font-medium">
                                    Il y a {formatDistance(Date.now(), new Date(createdAt), {locale : fr})}
                                </p>
                            </div>
                        </div>

                        {(userId === actualUserId && editable) &&(
                            <div className="opacity-60 hover:opacity-100 transition-opacity duration-200">
                                <PostMenuEdit postId={idPost} activities={activities} trainings={trainings} content={content} activity_id={activity?.id} training_id={training?.id}/>
                            </div>
                        )}
                    </div>
                </CardHeader>

                <CardContent className="space-y-4">
                    {content && (
                        <p className={`whitespace-pre-line break-words leading-relaxed ${medias.length > 0 ? 'text-base' : 'text-lg'} text-gray-700`}>
                            {urlify(content, 'text-primary hover:text-primary/80 underline transition-colors')}
                        </p>
                    )}

                    {medias.length > 0 &&(
                        <div className="relative group rounded-2xl overflow-hidden bg-black/5">
                            {extension[extension.length - 1] === "mp4" ? (
                                <video
                                    alt={content}
                                    controls
                                    className="w-full h-auto max-h-[600px] object-contain rounded-2xl"
                                >
                                    <source src={medias[0]?.path}/>
                                </video>
                            ) : (
                                <div className="relative">
                                    <img
                                        src={medias[0]?.path}
                                        alt={content}
                                        className={`w-full h-auto max-h-[600px] object-contain rounded-2xl transition-all duration-500 ${
                                            imageLoaded ? 'blur-0 scale-100' : 'blur-sm scale-105'
                                        }`}
                                        onLoad={() => setImageLoaded(true)}
                                    />
                                    {!imageLoaded && (
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {(training || activity) && (
                        <div className="grid md:grid-cols-2 gap-3 pt-2">
                            {training &&(
                                <Link href={`/events/${training.slug}`} className="group">
                                    <div className="p-3 border-2 border-primary/20 rounded-xl flex gap-4 hover:border-primary hover:shadow-lg hover:scale-[1.02] transition-all duration-300 h-full bg-gradient-to-br from-primary/5 to-transparent">
                                        <div className="flex-shrink-0">
                                            <img
                                                src={training.documents[0]?.path}
                                                alt={training.name}
                                                width={80}
                                                height={80}
                                                className="aspect-square object-cover object-center rounded-lg group-hover:scale-105 transition-transform duration-300"
                                            />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <h5 className="text-primary text-lg font-bold group-hover:text-primary/80 transition-colors line-clamp-1">
                                                {training.name}
                                            </h5>
                                            <p className="text-sm text-gray-600 line-clamp-1">{training.address}</p>
                                            <p className="text-sm text-gray-500 font-medium">{reworkDate(training.date_event, false, 'fr', true)}</p>
                                        </div>
                                    </div>
                                </Link>
                            )}
                            {activity &&(
                                <Link href={`/activities/${activity.slug}`} className="group">
                                    <div className="p-3 border-2 border-primary/20 rounded-xl flex gap-4 hover:border-primary hover:shadow-lg hover:scale-[1.02] transition-all duration-300 h-full bg-gradient-to-br from-primary/5 to-transparent">
                                        <div className="flex-shrink-0">
                                            <img
                                                src={activity.documents[0]?.path}
                                                alt={activity.title}
                                                width={80}
                                                height={80}
                                                className="aspect-square object-cover object-center rounded-lg group-hover:scale-105 transition-transform duration-300"
                                            />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <h5 className="text-primary text-lg font-bold group-hover:text-primary/80 transition-colors line-clamp-1">
                                                {activity.title}
                                            </h5>
                                            <p className="text-sm text-gray-600 line-clamp-1">{activity.address}</p>
                                            <p className="text-sm text-gray-500 font-medium">{reworkDate(activity.date_event, false, 'fr', true)}</p>
                                        </div>
                                    </div>
                                </Link>
                            )}
                        </div>
                    )}
                </CardContent>

                <CardFooter className="block pt-2 pb-4">
                    <div className="flex justify-between items-center mb-3 px-2">
                        <button
                            onClick={() => setLikeOpen(true)}
                            className={`flex items-center gap-2 group hover:scale-105 transition-transform duration-200 ${
                                isLike ? 'text-red-500' : 'text-gray-500 hover:text-red-500'
                            }`}
                        >
                            <FaHeart className={`transition-all duration-200 ${isLike ? 'scale-110' : 'group-hover:scale-110'}`}/>
                            <span className="font-semibold">
                                {likes.length} {likes.length > 1 ? 'J\'aimes' : 'J\'aime'}
                            </span>
                        </button>

                        {comments.length > 0 && (
                            <button className="flex items-center gap-2 text-gray-500 hover:text-primary transition-colors group">
                                <FaRegCommentAlt className="group-hover:scale-110 transition-transform"/>
                                <span className="font-semibold">{comments.length}</span>
                            </button>
                        )}
                    </div>

                    {editable &&(
                        <>
                            <div className="flex justify-around w-full border-t-2 border-gray-100 pt-2 gap-2">
                                <div className="flex-1">
                                    <LikeButton type={"posts"} idType={idPost} isLiked={isLike}/>
                                </div>
                                <button
                                    className={`flex-1 flex items-center justify-center gap-2 hover:bg-gradient-to-r hover:from-primary/10 hover:to-primary/5 px-4 py-2 rounded-lg transition-all duration-200 ${
                                        commentOpen ? 'font-semibold text-primary bg-primary/10' : 'text-gray-600'
                                    }`}
                                    onClick={() => setCommentOpen(!commentOpen)}
                                >
                                    <FaRegCommentAlt size={18} className={commentOpen ? 'scale-110' : ''}/>
                                    <span>Commenter</span>
                                </button>
                            </div>

                            <div className={`transition-all duration-300 ease-in-out overflow-hidden ${
                                commentOpen ? 'max-h-[2000px] opacity-100 mt-4' : 'max-h-0 opacity-0'
                            }`}>
                                <CommentSection postId={idPost} comments={comments} userId={userId} actualUserId={actualUserId}/>
                            </div>
                        </>
                    )}
                </CardFooter>
            </Card>
            <LikeModal likes={likes} likeOpen={likeOpen} setLikeOpen={setLikeOpen}/>
        </>
    )
}